﻿export const QuoteStep = Object.freeze({
    QuoteCart: 1,
    AddressDetails: 2,
    QuoteComment: 3,
    ConfirmQuote: 4
});